// extracted by mini-css-extract-plugin
module.exports = {"inlineBadge":"count-badge_component_inlineBadge__UDzhG","badge":"count-badge_component_badge__omJPW"};